module.exports = __webpack_public_path__ + "img/god-rest-ye.2db36251.jpeg";